import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cloud-based-software-development',
  templateUrl: './cloud-based-software-development.component.html',
  styleUrls: ['./cloud-based-software-development.component.scss']
})
export class CloudBasedSoftwareDevelopmentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
